export const TABS = {
  templates: "templates",
  favorites: "favorites",
};
